import {GraphPoint, Node} from "../../../model/Graph";

export const SPACING = 100;
export const CONNECT_SPACING = SPACING * 2;
export const Y_CTX_SPACING = 400;
export const X_SLICE_SPACING = SPACING;
export const Y_SLICE_SPACING = SPACING + 25;
export const SLICE_HEIGHT = 900;


export const getNextGeo = (addedNodes: {[nodeId: string]: Node}): GraphPoint => {
  const addedNodesList = Object.values(addedNodes);

  if(addedNodesList.length === 0) {
    // Default padding
    return {
      x: SPACING,
      y: Y_CTX_SPACING
    }
  }

  const lastNode = addedNodesList.pop()!;

  return {
    x: lastNode.getGeometry().x + lastNode.getSize().width + 200,
    y: Y_CTX_SPACING
  }
}

export const geoRight = (node: Node, spacing?: number): GraphPoint => {
  const geo = node.getGeometry();
  const size = node.getSize();

  return {
    x: geo.x + size.width + (typeof spacing === "undefined" ? CONNECT_SPACING : spacing),
    y: geo.y,
  }
}

export const geoBelow = (node: Node, spacing?: number): GraphPoint => {
  const geo = node.getGeometry();
  const size = node.getSize();

  return {
    x: geo.x,
    y: geo.y + size.height + (typeof spacing === "undefined" ? CONNECT_SPACING : spacing),
  }
}

export const geoAboveRight = (node: Node, xSpacing?: number, ySpacing?: number): GraphPoint => {
  const geo = node.getGeometry();
  const size = node.getSize();

  return {
    x: geo.x + size.width + (typeof xSpacing === "undefined" ? SPACING : xSpacing),
    y: geo.y - (typeof ySpacing === "undefined" ? CONNECT_SPACING : ySpacing),
  }
}

export const geoBelowRight = (node: Node, xSpacing?: number, ySpacing?: number): GraphPoint => {
  const geo = node.getGeometry();
  const size = node.getSize();

  return {
    x: geo.x + size.width + (typeof xSpacing === "undefined" ? SPACING : xSpacing),
    y: geo.y + size.height + (typeof ySpacing === "undefined" ? CONNECT_SPACING : ySpacing),
  }
}
